<template>
  <div id="app">
    <Header />
    <router-view />
    <Footer />
    <FloatingContact />
    <FloatingAI />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import FloatingContact from './components/FloatingContact.vue'
import FloatingAI from './components/FloatingAI.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    FloatingContact,
    FloatingAI
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

a {
  text-decoration: none;
  color: inherit;
}

ul {
  list-style: none;
}

img {
  max-width: 100%;
  height: auto;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.page-title {
  text-align: center;
  padding: 40px 0;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.page-title h1 {
  font-size: 32px;
  margin-bottom: 10px;
}

.page-title p {
  font-size: 16px;
  opacity: 0.9;
}

.section {
  padding: 60px 0;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
}

.section-title h2 {
  font-size: 28px;
  color: #333;
  margin-bottom: 10px;
}

.section-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 3px;
  background: #1890ff;
  margin: 15px auto 0;
}

.btn {
  display: inline-block;
  padding: 12px 30px;
  background: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 16px;
}

.btn:hover {
  background: #40a9ff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

@media (max-width: 768px) {
  .page-title h1 {
    font-size: 24px;
  }
  
  .section {
    padding: 40px 0;
  }
  
  .section-title h2 {
    font-size: 24px;
  }
}
</style>
